var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOldRegrabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.633,
    height: 18,
    viewBox: "0 0 20.633 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oldRegrabIcon",
    transform: "translate(-1803.367 -310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "historical-data-6",
    d: "M12.267,4.2V8.4h4.2a.6.6,0,1,1,0,1.2h-5.4V4.2a.6.6,0,1,1,1.2,0Zm-.6-4.2a8.786,8.786,0,0,0-7.8,4.56V1.8a.567.567,0,0,0-.6-.6.567.567,0,0,0-.6.6V6h4.2a.567.567,0,0,0,.6-.6.567.567,0,0,0-.6-.6h-1.8a7.647,7.647,0,0,1,6.6-3.6,7.8,7.8,0,0,1,0,15.6c-4.32,0-8.4-4.833-8.4-4.473A9.537,9.537,0,0,0,11.667,18a9.066,9.066,0,0,0,9-9A9.066,9.066,0,0,0,11.667,0Z",
    transform: "translate(1803.333 310)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_icon-social-twitter_211920",
    "data-name": "iconfinder icon-social-twitter 211920",
    d: "M-281.338,65.5a4.241,4.241,0,0,1-1.178.314,2.006,2.006,0,0,0,.9-1.1,4.149,4.149,0,0,1-1.3.481,2.1,2.1,0,0,0-2.9-.095,1.959,1.959,0,0,0-.65,1.454,1.893,1.893,0,0,0,.053.453,5.876,5.876,0,0,1-4.229-2.08,1.957,1.957,0,0,0,.636,2.657,2.048,2.048,0,0,1-.93-.248v.025a2.006,2.006,0,0,0,1.645,1.952,2.118,2.118,0,0,1-.54.07,1.982,1.982,0,0,1-.386-.037,2.048,2.048,0,0,0,1.92,1.382,4.2,4.2,0,0,1-2.549.852,4.216,4.216,0,0,1-.489-.028,5.877,5.877,0,0,0,3.142.9,5.708,5.708,0,0,0,5.84-5.664c0-.085,0-.172-.006-.257A4.132,4.132,0,0,0-281.338,65.5Z",
    transform: "translate(2094.836 254.51)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldRegrabIcon);
export default __webpack_public_path__ + "static/media/oldRegrabIcon.10a0cc90ab3ba72fd5048c97de36340c.svg";
export { ForwardRef as ReactComponent };